import { debounce } from 'throttle-debounce';
import { ref } from 'vue';

import useHeader from './header';

export default function useBanners({ store, router }) {
  const { getHeader } = useHeader({ store, router });

  const bannersAppearEvent = ref([]);

  function sendBannersClickEvent({ id, slotId }) {
    if (!id || !slotId) return;

    const body = {
      banner:
        {
          id,
          slotId,
        },
    };

    return store.$apiBFF.sendBasePersEvent({ type: 'banner-click', data: { header: getHeader(), body } });
  }

  function addBannersAppearEvent(id, slotId) {
    bannersAppearEvent.value.push({ id, slotId });
  }

  function sendBannersAppearEvent() {
    const banners = bannersAppearEvent.value.splice(0);
    if (banners.length > 0) {
      const body = { banners };
      return store.$apiBFF.sendBasePersEvent({ type: 'banners-appear', data: { header: getHeader(), body } });
    }
  }

  return {
    sendBannersClickEvent,
    addBannersAppearEvent,
    sendBannersAppearEvent,
    debouncedEventBanners: debounce(1000, () => {
      sendBannersAppearEvent();
    }),
  };
}
